import { render, staticRenderFns } from "./ProfileRole.vue?vue&type=template&id=3e0e747c&scoped=true&"
import script from "./ProfileRole.vue?vue&type=script&lang=ts&"
export * from "./ProfileRole.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileRole.vue?vue&type=style&index=0&id=3e0e747c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0e747c",
  null
  
)

export default component.exports